import axios from "axios";
import Cookies from 'js-cookie';
import { API_SERVER_URL, postUserAccountsRefresh, postSaveLog } from './api';
import { Modal } from "antd";


// Axios 인스턴스 생성
const instance = axios.create({
	baseURL: API_SERVER_URL,   // 요청 보낼 서버 주소 적는 곳
	headers: {
		"Content-Type": "application/json", //헤더 기본 설정
	},
	// withCredentials는 JWT 사용 시 불필요 (쿠키 기반 인증이 아님)
});

// 요청 전에 실행되는 인터셉터
instance.interceptors.request.use(
    function (config) {
		const access_token = Cookies.get("access_token");
		const auth_user = Cookies.get("auth_user");

		if (access_token && auth_user) {
			config.headers["Authorization"] = `Bearer ${access_token}`;
			config.headers["Auth-User"] = auth_user;
		}
		
		const auth_companyCode = Cookies.get("auth_companyCode");
		// 관리자의 경우 회사코드 변경 가능
		const logCompany = config.logCompany ? config.logCompany : auth_companyCode;
		const logType = config.logType ? config.logType : config.url.replace(API_SERVER_URL, '');
		// Get의 경우 URL과 파라미터 분리
		let logUrl;
		let logParam;
		
		if (config.url.indexOf('?') > -1) {
			logUrl = config.url.substring(0, config.url.indexOf('?') - 1);
			logParam = config.url.substring(config.url.indexOf('?') + 1);
		} else {
			logUrl = config.url;
			logParam = config.logParam;
		}
		
		// POST이면서 세션이 있어야 함. 단, 직접 log기록하는 경우 제외
		if ((config.method == 'POST' || config.method == 'post')
			&& access_token && logType != 'log') {
			axios.post(postSaveLog(), {
				com_cd: logCompany,
				log_type: logType,
				log_user: auth_user,
				log_url: logUrl,
				log_param: logParam,
			}, config);
		}
		
		return config;
	},
	function (error) {		
        return Promise.reject(error);
	}
);

//AccessToken이 만료됐을때 처리
// instance.interceptors.response.use(
//   function (response) { return response; },
//   async (error) => {
//     const { config, response: { status }, } = error;

//     if (status === 401 || status === 403) {

//       //Logout으로 Token이 없을 경우
//       if (error.response.data.detail === "자격 인증데이터(authentication credentials)가 제공되지 않았습니다.") {

//         Modal.error({title: "세션이 종료되어 로그아웃됩니다.", okText:"Close", onOk() {
//           //초기화면으로 이동
//           Cookies.remove('access_token');
//           Cookies.remove('refresh_token');
//           Cookies.remove('auth_companyCode');
//           Cookies.remove('auth_companyName');
//           Cookies.remove('auth_user');
//           Cookies.remove('auth_userName');
//           Cookies.remove('auth_superuser');
//           localStorage.removeItem('code_list');
//           window.location.replace("/");
//         }})

//       } else if (error.response.data.code === "token_not_valid") {
//         //세션 timeout으로 Token 재생성 필요
//         const originalRequest = config;
//         const access_token = Cookies.get("access_token");
//         const refresh_token = Cookies.get("refresh_token");
//         // token refresh 요청
//         await axios.post( postUserAccountsRefresh()
//                         , {refresh: refresh_token,}
//                         , { headers: { Authorization: `Bearer ${access_token}` } })
//         .then((response) => {
//           // 새로운 토큰 저장
//           Cookies.set("access_token", response.data.access);
//           originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
//           // 401로 요청 실패했던 요청 새로운 accessToken으로 재요청
//           return axios(originalRequest);
//         })
//         .catch((error) => {
//           // refresh token 만료로 종료
//           console.log("axios.js ------- 106 에러");
//           console.dir(error);
//           Modal.error({title: "세션 타임아웃으로 로그아웃됩니다.", okText:"Close", onOk() {

//             // 쿠키에서 인증 토큰 삭제하기
//             Cookies.remove('access_token');
//             Cookies.remove('refresh_token');
//             Cookies.remove('auth_companyCode');
//             Cookies.remove('auth_companyName');
//             Cookies.remove('auth_user');
//             Cookies.remove('auth_userName');
//             Cookies.remove('auth_superuser');
//             localStorage.removeItem('code_list');
//             window.location.replace("/");

//           }})  
//         })
//       } else {
//         console.log("axios.js ---- 124 error");
//         console.dir(error);
//       }
//     } 

//     console.log("axios.js ---- 129 error");
//     console.dir(error);
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );


instance.interceptors.response.use(
	function (response) { return response; },
	async (error) => {
		const { config, response } = error;
		const status = response?.status;

		if (status === 401 || status === 403) {
            try{
                //세션 timeout으로 Token 재생성 필요
                const originalRequest = config;
                const access_token = Cookies.get("access_token");
                const refresh_token = Cookies.get("refresh_token");

                // refresh token이 없으면 바로 로그아웃
                if (!refresh_token) {
                    tokenModalError("세션이 만료되었습니다. 다시 로그인해주세요.");
                    return Promise.reject(error);
                }

                // token refresh 요청
                const refreshResponse = await axios.post(
                    postUserAccountsRefresh()
                    , { refresh: refresh_token, }
                    , { headers: { Authorization: `Bearer ${access_token}` } }
                );

                Cookies.set("access_token", refreshResponse.data.access);
                Cookies.set("refresh_token", refreshResponse.data.refresh);
                originalRequest.headers.Authorization = `Bearer ${refreshResponse.data.access}`;
                // 401로 요청 실패했던 요청 새로운 accessToken으로 재요청
                return axios(originalRequest);
            } catch (refreshError) {
                // refresh token도 만료되었거나 갱신 실패
                tokenModalError("세션 타임아웃으로 로그아웃됩니다.");
                return Promise.reject(refreshError);
            }

        	// //세션 timeout으로 Token 재생성 필요
			// const originalRequest = config;
			// const access_token = Cookies.get("access_token");
			// const refresh_token = Cookies.get("refresh_token");
			// // token refresh 요청
			// await axios.post(postUserAccountsRefresh()
			// 	, { refresh: refresh_token, }
			// 	, { headers: { Authorization: `Bearer ${access_token}` } })
			// .then((response) => {
			// 	// 새로운 토큰 저장
			// 	// Cookies.set("access_token", response.data.access);
            //     // console.log("refresh token success");
			// 	originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
			// 	// 401로 요청 실패했던 요청 새로운 accessToken으로 재요청
			// 	return axios(originalRequest);
			// })
			// .catch((error) => {
			// 	// refresh token 만료로 종료
			// 	// console.log("axios.js ------- refresh token fail");
			// 	// console.dir(error);
			// 	tokenModalError("세션 타임아웃으로 로그아웃됩니다.");
			// })
		} else {
			// Do something with response error
			return Promise.reject(error);
		}
	}
);


function tokenModalError(message) {
	Modal.error({
		title: message,
		okText: "Close",
		onOk() {
			// 쿠키와 로컬 스토리지에서 인증 관련 데이터 삭제
			Cookies.remove("access_token");
			Cookies.remove("refresh_token");
			Cookies.remove("auth_companyCode");
			Cookies.remove("auth_companyName");
			Cookies.remove("auth_user");
			Cookies.remove("auth_userName");
			Cookies.remove("auth_superuser");
			localStorage.removeItem("code_list");

			// 로그인 페이지로 리다이렉트
			window.location.replace("/");
		},
	});
}

export default instance;